import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { PageHeader, EmptyState } from "../../components/Common";
import { Link } from "react-router-dom";
import { ClipboardList, Check } from "lucide-react";

export default function StudentTests() {
  const [tests, setTests] = useState([]);
  const [attempts, setAttempts] = useState([]);

  useEffect(() => {
    (async () => {
      const [t, a] = await Promise.all([api.get("/tests"), api.get("/student/attempts")]);
      setTests(t.data);
      setAttempts(a.data);
    })();
  }, []);

  const attempted = new Set(attempts.map((a) => a.test_id));

  return (
    <div>
      <PageHeader title="Tests" subtitle="Take your MCQ tests, view your progress." />

      {tests.length === 0 ? (
        <EmptyState title="No tests available" desc="Your teachers haven't created any tests yet." icon={ClipboardList} />
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {tests.map((t) => {
            const done = attempted.has(t.id);
            const attempt = attempts.find((a) => a.test_id === t.id);
            return (
              <div key={t.id} data-testid={`test-card-${t.id}`} className="bg-white border border-slate-200 rounded-xl p-5 ym-card-hover">
                <div className="flex items-start justify-between">
                  <div className={`w-10 h-10 rounded-lg grid place-items-center ${done ? "bg-emerald-50 text-emerald-600" : "bg-blue-50 text-blue-600"}`}>
                    {done ? <Check className="h-5 w-5" /> : <ClipboardList className="h-5 w-5" />}
                  </div>
                  {done && attempt && (
                    <span className={`text-sm font-bold ${attempt.percent >= 70 ? "text-emerald-600" : attempt.percent >= 40 ? "text-amber-600" : "text-rose-600"}`}>
                      {attempt.percent}%
                    </span>
                  )}
                </div>
                <h3 className="mt-4 font-heading font-bold text-slate-900">{t.title}</h3>
                <div className="mt-2 flex gap-3 text-xs text-slate-500">
                  <span>{t.questions.length} Qs</span>
                  <span>{t.duration_minutes} min</span>
                </div>
                {!done ? (
                  <Link to={`/dashboard/student/tests/${t.id}`} data-testid={`start-test-${t.id}`}
                    className="mt-4 block text-center px-4 py-2 rounded-lg bg-blue-600 text-white text-sm font-semibold hover:bg-blue-700">
                    Start test
                  </Link>
                ) : (
                  <div className="mt-4 text-center px-4 py-2 rounded-lg bg-slate-100 text-slate-600 text-sm font-semibold">Completed</div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
